import React from "react";

import ConfigBox from "../../components/Dashboard/ConfigBox";
import { BackButton } from "../../components/AtomComponents";

import './SplashConfig.scss';

export function SplashConfig() {
  React.useEffect(() => {
    const config = JSON.parse(localStorage.getItem("PxConfig") || "");
    document.title = String(config.siteTitle) + " - Splash Config";
  }, []);

  const UiBoxes = [
    {
      header: "Tenant Splash Page Config",
      description:"Splash page configuration for specific tenant",
      redirect: "splash-config/tenant",
    },
    {
      header: "Global Splash Page Config",
      description:"Splash page configuration for all tenants",
      redirect: "splash-config/global",
    },
  ];
  return (
    <div className="px-SplashConfig grid-x">
      <div className="cell small-6 medium-6 px-one-line-data">
        <BackButton />
        <h3 className="small-12">Splash Page Config</h3>
      </div>

      <div className="small-12 margin-top-3">
        {UiBoxes.map((Uibox) => {
          return (
            <ConfigBox
              header={Uibox.header}
              redirect={Uibox.redirect}
              description={Uibox.description}
              key={Uibox.header}
            />
          );
        })}
      </div>
    </div>
  );
}



export default SplashConfig;
